<template>
  <div>
    <div id="header">
        <img :src="require('/src/assets/img/logo/fnedu.png')" @click="goPath('/mobile/home')" />
        <a href="https://www.sdnlab.com/" target="_blank"><img :src="require('/src/assets/img/logo/sdnlab.png')" /></a>
    </div>
    <div class="main">
      <!-- 登录 -->
      <div v-if="loginModal.visible">
        <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="loginModal.login_error">{{ loginModal.login_error }}。</van-notice-bar>
        <van-form class="log_form" ref="loginForm">
          <van-cell-group :border="false">
            <van-cell title="用户登录" title-class="title_bg">
              <template #value>
                <a href="javascript:;" @click="openRegister()">注册</a>
              </template>
            </van-cell>
            <van-field
              v-model="loginModal.loginForm.tel"
              placeholder="请输入手机号/用户名/邮箱"
              :rules="rules.tel"
            />
            <PwdInput v-model:pwd="loginModal.loginForm.pwd" :rules="rules.pwd" />
            <!-- 校验 -->
            <van-field :rules="rules.verify" v-model="loginModal.loginForm.verify" class="slider_verify">
              <template #input>
                <div style="width:100%;">
                  <SliderVerify @result="getLoginResult"></SliderVerify>
                </div>
              </template>
            </van-field>
            <van-cell class="extra" v-if="!useCookie">
              <template #title>
                <span style="color: red;">您的手机浏览器不支持或已经禁用cookie,无法正常登录,请开启或更换其他浏览器</span>
              </template>
            </van-cell>
            <van-cell class="extra">
              <template #title>
                <van-button block type="primary" @click="submitLoginForm()">立即登录</van-button>
              </template>
            </van-cell>
            <van-cell class="extra">
              <template #title>
                <van-checkbox shape="square" icon-size="14" v-model="loginModal.loginForm.autoLogin">下次自动登录</van-checkbox>
              </template>
              <template #value>
                <a href="javascript:;" @click="showForgetPwd">忘记密码？</a>
              </template>
            </van-cell>
          </van-cell-group>
        </van-form>
        <van-divider :style="{ color: '#666', borderColor: '#333', padding: '0 16px', width: '80%', margin: '10px auto 20px' }">第三方账户登录</van-divider>
        <div class="third_login">
          <a href="#" @click="startThirdPartyLogin('qq')"><i class="iconfont icon-111_huaban1" style="color:#18acfc;"></i></a>
          <a href="#" v-if="false" @click="startThirdPartyLogin('weixin')"><i class="iconfont icon-111-02" style="color:#00bb29;"></i></a>
          <a href="#" @click="startThirdPartyLogin('weibo')"><i class="iconfont icon-111-03" style="color:#d72b2b;"></i></a>
          <a href="#" @click="startThirdPartyLogin('baidu')"><i class="iconfont icon-111-04" style="color:#306cff;"></i></a>
          <a href="#" @click="startThirdPartyLogin('github')"><i class="iconfont icon-111-05" style="color:#1f76b6;"></i></a>
        </div>
      </div>
      <!-- 注册 -->
      <div v-else>
        <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="loginModal.register_error">{{ loginModal.register_error }}。</van-notice-bar>
        <van-form class="log_form" ref="registerForm">
          <van-cell-group>
            <van-cell title="用户注册" title-class="title_bg">
              <template #value>
                <a href="javascript:;" @click="openLogin()">登录</a>
              </template>
            </van-cell>
            <van-field class="field_tel"
              v-model="loginModal.registerForm.register_tel"
              name="register_tel"
              type="tel"
              label="CN+86"
              placeholder="请输入手机号"
              :rules="rules.register_tel"
            />
            <PwdInput v-model:pwd="loginModal.registerForm.register_pwd" :rules="rules.register_pwd" name="register_pwd" />
            <van-field v-if="!loginModal.isVerify"
              v-model="loginModal.registerForm.yzm"
              :placeholder="loginModal.registerForm.yzm_placeholder"
              :rules="rules.yzm"
            >
              <template #button>
                <van-button size="small" type="primary" v-if="!loginModal.isGetYzm" @click="getSms()">获取验证码</van-button>
                <van-button size="small" type="primary" disabled v-else>{{ loginModal.countdown }}</van-button>
              </template>
            </van-field>
            <!-- 校验 -->
            <van-field v-else :rules="rules.verify" class="slider_verify">
              <template #input>
                <div style="width:100%;">
                  <SliderVerify @result="getRegisterResult"></SliderVerify>
                </div>
              </template>
            </van-field>
            <van-cell class="extra" v-if="!useCookie">
              <template #title>
                <span style="color: red;">您的手机浏览器不支持或已经禁用cookie,无法正常登录,请开启或更换其他浏览器</span>
              </template>
            </van-cell>
            <van-cell class="extra">
              <template #title>
                <van-button block type="primary" @click="submitRegisterForm()">立即注册</van-button>
              </template>
            </van-cell>
            <van-field :rules="rules.agree" class="custom_van_checkbox">
              <template #input>
                <van-checkbox class="agreement" shape="square" icon-size="16" v-model="loginModal.registerForm.agree">同意<router-link to="/mobile/agreement" target="_blank">《未来网络学堂用户注册使用协议》</router-link> </van-checkbox>
              </template>
            </van-field>
          </van-cell-group>
        </van-form>
      </div>
    </div>

    <!-- 忘记密码 -->
    <van-popup v-model:show="forgetPwdModal.visible" position="right" :style="{ width: '100%', height: '100%' }" @close="closeForgetPwdModal">
      <van-nav-bar
        z-index="10"
        left-arrow
        title="忘记密码"
        @click-left="forgetPwdModal.visible = false"></van-nav-bar>
      <div v-if="forgetPwdModal.visible">
        <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="forgetPwdModal.error">{{ forgetPwdModal.error }}。</van-notice-bar>
        <van-form class="log_form" ref="forgetPwdForm">
          <van-cell-group>
            <van-field class="field_tel"
              v-model="forgetPwdModal.form.forget_tel"
              name="forget_tel"
              type="tel"
              label="CN+86"
              placeholder="请输入手机号"
              :rules="rules.forget_tel"
            />
            <PwdInput v-model:pwd="forgetPwdModal.form.pwd" :rules="rules.pwd" placeholder="请输入新密码" name="pwd" />
            <van-field v-if="!forgetPwdModal.isVerify"
              v-model="forgetPwdModal.form.yzm"
              :placeholder="forgetPwdModal.form.yzm_placeholder"
              :rules="rules.yzm"
            >
              <template #button>
                <van-button size="small" type="primary" v-if="!forgetPwdModal.isGetYzm" @click="getForgetSms()">获取验证码</van-button>
                <van-button size="small" type="primary" disabled v-else>{{ forgetPwdModal.countdown }}</van-button>
              </template>
            </van-field>
            <!-- 校验 -->
            <van-field v-else :rules="rules.verify" class="slider_verify">
              <template #input>
                <div style="width:100%;">
                  <SliderVerify @result="getForgetPwdResult"></SliderVerify>
                </div>
              </template>
            </van-field>
            <van-cell class="extra">
              <template #title>
                <van-button block type="primary" @click="submitForgetForm()">确定</van-button>
              </template>
            </van-cell>
          </van-cell-group>
        </van-form>
      </div>
    </van-popup>

    <!-- 补充手机号 -->
    <van-popup v-model:show="addCellPhoneModal.visible" position="right" :style="{ width: '100%', height: '100%' }" @close="closeAddPhoneModal">
      <van-nav-bar
        z-index="10"
        left-arrow
        title="补充手机号码"
        @click-left="addCellPhoneModal.visible = false"></van-nav-bar>
      <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="addCellPhoneModal.error">{{ addCellPhoneModal.error }}。</van-notice-bar>
      <van-form class="log_form" ref="addCellPhoneForm">
        <van-cell-group>
          <van-field class="field_tel"
            v-model="addCellPhoneModal.form.addtel"
            name="addtel"
            type="tel"
            label="CN+86"
            placeholder="请输入手机号"
            :rules="rules.addtel"
          />
          <van-field v-if="!addCellPhoneModal.isVerify"
            v-model="addCellPhoneModal.form.yzm"
            :placeholder="addCellPhoneModal.form.yzm_placeholder"
            :rules="rules.yzm"
          >
            <template #button>
              <van-button size="small" type="primary" v-if="!addCellPhoneModal.isGetYzm" @click="getAddSms()">获取验证码</van-button>
              <van-button size="small" type="primary" disabled v-else>{{ addCellPhoneModal.countdown }}</van-button>
            </template>
          </van-field>
          <!-- 校验 -->
          <van-field v-else :rules="rules.verify" class="slider_verify">
            <template #input>
              <SliderVerify @result="getAddPhoneResult"></SliderVerify>
            </template>
          </van-field>
          <van-cell class="extra">
            <template #title>
              <van-button block type="primary" @click="submitAddPhoneForm()">确定</van-button>
            </template>
          </van-cell>
        </van-cell-group>
      </van-form>
    </van-popup>

  </div>
</template>

<script>
  import PwdInput from 'components/mobile/common/PwdInput'
  import SliderVerify from 'components/mobile/common/SliderVerify'
  import ResetPwdModal from 'components/ResetPwdModal.vue'
  import { checkPhone, checkPassword, routePathHandler } from 'utils/mobile/common.js'
  import { checkPhoneExist, SendSms, RegisterUser } from 'api/user/auth/register'
  import { GetUserState, LoginUser, LogOutUser, ThirdPartyLogin, AddCellPhone, ForgetPWD, updateUserLoginState, oauthAuthLogin, getDomainSite } from 'api/user/auth/login'
  import { showMessage } from 'api/base/mobile/message'
  import { setCookie, getCookie } from "api/base/axios";

  export default {
    components: {
      PwdInput,
      SliderVerify,
      ResetPwdModal
    },
    data() {
      let checkPhoneExistRule = (value, rule) => {
        return new Promise(resolve => {
          checkPhoneExist(value).then((res) => {
            if (!res.result) {
              resolve(true)
            } else {
              resolve('手机号码已经被注册')
            }
          }).catch(err => {
            resolve('服务异常，请稍后再试')
          });
        })
      }

      let checkPhoneNotExistRule = (value, rule) => {
        return new Promise(resolve=>{
          checkPhoneExist(value).then((res) => {
            if (!res.result) {
              resolve('该手机号码不存在')
            } else {
              resolve(true)
            }
          }).catch(err => {
            resolve('服务异常，请稍后再试')
          });
        })
      }
      return {
        showLogin: false,
        loginModal: {
          visible: true,
          login_error: '',
          isGetYzm: false,
          isVerify: false,
          countdown: '等待 60 s',
          loginForm: {
            tel: '',
            pwd: '',
            verify: '',
            autoLogin: false,
            oauth_token: ''
          },
          register_error: '',
          registerForm: {
            register_tel: '',
            register_pwd: '',
            yzm: '',
            yzm_placeholder: '请输入短信验证码',
            agree: false,
            oauth_token: ''
          },
        },
        forgetPwdModal: {
          error: '',
          visible: false,
          isGetYzm: false,
          isVerify: false,
          countdown: '等待 60 s',
          form: {
            forget_tel: '',
            yzm: '',
            yzm_placeholder: '请输入短信验证码',
            pwd: '',
            verify: '',
          }
        },
        addCellPhoneModal: {
          error: '',
          visible: false,
          isGetYzm: false,
          isVerify: false,
          countdown: '等待 60 s',
          form: {
            addtel: '',
            yzm: '',
            yzm_placeholder: '请输入短信验证码',
            verify: '',
            token: '',
            target: '',
            user_id: '',
            oauth_token: ''
          }
        },
        rules: {
          register_tel: [
            { required: true, validator: checkPhone, message: '请输入手机号', trigger: 'onBlur' },
            { validator: checkPhoneExistRule, trigger: 'onBlur' }
          ],
          register_pwd: [
            { required: true, message: '请输入密码', trigger: 'onBlur' },
            { validator: checkPassword, trigger: 'onBlur' }
          ],
          yzm: [
            { required: true, message: '请输入验证码', trigger: 'onBlur' },
          ],
          verify: [
            { required: true, message: '请进行拼图验证', trigger: 'onBlur' },
          ],
          agree: [
            { required: true, message: '请同意协议', trigger: 'onBlur' },
          ],

          tel: [
            { required: true, message: '请填写账号', trigger: 'onBlur' },
          ],
          pwd: [
            { required: true, message: '请输入密码', trigger: 'onBlur' },
            { validator: checkPassword, trigger: 'blur' }
          ],

          addtel: [
            { required: true, validator: checkPhone, trigger: 'onBlur' },
          ],

          forget_tel: [
            { required: true, validator: checkPhone, trigger: 'onBlur' },
            { required: true, validator: checkPhoneNotExistRule, trigger: 'onBlur' }
          ]
        },
        user:{
          is_authenticated: false,
          user_id: null,
          user_name: null,
          cellphone: null,
        },
        resetModalVisible: false,
        cartItemCount: '',
        checkLoginTime: null,
        oauth_mode: false,
        oauth_loading: true,
        login_loading_msg: '',
        useCookie: true,
        domainSite: 'https://www.fnedu.com',
      }
    },
    created() {
      let oauth_token = this.$route.query.oauth_token;
      if (oauth_token) {
        this.loginModal.loginForm.oauth_token = oauth_token;
        this.loginModal.registerForm.oauth_token = oauth_token;
        this.addCellPhoneModal.form.oauth_token = oauth_token;
        this.oauth_mode = true;
      }

      let oauth_register = this.$route.query.oauth_register;

      if (oauth_register) {
          this.showLogin = false;
          this.loginModal.login_error = "";
          this.loginModal.isVerify = false;
          this.changeFormAnimation(that => {
            that.loginModal.visible = false;
          });
      } else {
          this.load_user_status()
      }
      this.load_domain_site()
    },
    mounted() {
      this.changeFormAnimation();
      window.newThirdBindCellphone = this.newThirdBindCellphone;
      window.showLoginMessage = this.showThirdBindMessage;
      this.canUseCookie()
    },
    methods: {
      routePathHandler,
      async load_user_status(){

        const that = this;

        await GetUserState({}).then((res) => {
            if (res.id) {

              if (this.oauth_mode) {
                that.oauth_auto_login();
              } else {
                this.goNext();
              }

            } else {
              this.checkLoginTime = setInterval(this.checkUserHasLogin, 10000);
            }
        }).catch(error => {
        });
      },

      async oauth_auto_login(){

        this.oauth_loading = true;
        this.login_loading_msg = '正在自动登录中 ...';

        await oauthAuthLogin(this.loginModal.loginForm.oauth_token).then(result => {

          if (result.succeed) {
            window.location.href = result.notify_session_url + "&refer_url=" + this.$route.query.url;
          } else {
            //showMessage('自动登录失败,请手动进行登录', 'error');
          }
        }).catch(err => {
        });
      },
      load_domain_site() {
        getDomainSite().then(res => {
          if(res.code == 0){
            this.domainSite = res.domain_site
          }
        })
      },
      checkUserHasLogin() {
        let that = this;
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("result") && res.result === 0) {
            clearInterval(that.checkLoginTime)
            console.log("check 000000000000000000000000")
            that.goNext();
          }
        }).catch(error => {

        });
      },

      changeFormAnimation(callback) {
        const that = this;
        setTimeout(() => {
          if(callback) {
            callback(that);
          }
          that.showLogin = true;
        }, 500);
      },
      //登录
      getLoginStatus(val) {
        if(val) {
          this.loginModal.loginForm.verify = 'success';
        } else {
          this.loginModal.loginForm.verify = '';
        }
      },
      getLoginResult(val) {
        this.getLoginStatus(val)
        if(val === 'success') {
          this.loginModal.isVerify = true;
          //this.$refs.loginForm.clearValidate('verify');
        }
      },
      submitLoginForm() {
        this.loginModal.login_error = '';
        this.$refs.loginForm.validate().then(() => {
            LoginUser(this.loginModal.loginForm)
              .then((res) => {
                if (!res.result) {
                  if (res.notify_session_url) {
                    window.location.href = res.notify_session_url + "&refer_url=" + this.$route.query.url;
                  } else {
                    this.goNext();
                  }
                } else {
                  this.loginModal.login_error = res.msg
                }
              }).catch((err) => {
                showMessage('服务异常，请稍后再试')
            })
        }).catch(err=>{
          return false
        });
      },
      openRegister() {
        this.showLogin = false;
        this.loginModal.login_error = "";
        this.$refs.loginForm.resetValidation();
        this.loginModal.isVerify = false;
        this.changeFormAnimation(that => {
          that.loginModal.visible = false;
        });
      },
      // 第三方登录
      startThirdPartyLogin(type) {
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("error") && res.error === 'Not Login State') {
            let target = "";
            if (this.$route.query.oauth_token) {
              let url = this.$route.query.url ? this.$route.query.url : ""
              target = url + "&oauth_token=" + this.$route.query.oauth_token;
            } else {
              target = this.$route.query.next;
            }
            if(type == 'qq'){
              var redirect_uri = this.domainSite + '/mobile/login_success/qq-oauth2/qq-callback?target=' + next
              var url = 'https://graph.qq.com/oauth2.0/authorize?client_id=101196615&response_type=token&redirect_uri=' + encodeURIComponent(redirect_uri);
              location.href = url
              // QC.Login.showPopup({
              //   appId: '101196615',
              //   // redirectURI: 'http://127.0.0.1:8080/mobile/login_success/qq-oauth2/qq-callback?target=' + next
              //   redirectURI: 'https://www.fnedu.com/user/social-login/qq-oauth2/qq-callback?target=' + next
              // })
            }
            else {
              ThirdPartyLogin(type, target, 'mobile')
            }
          } else {
            this.$router.go(0);
          }
        }).catch(error => {
        });
      },
      newThirdBindCellphone(token, target_url) {
        this.addCellPhoneModal.form.token = token;
        this.addCellPhoneModal.form.target = target_url;
        this.loginModal.visible = false;
        this.addCellPhoneModal.visible = true;
      },
      showThirdBindMessage(message) {
        showMessage(message)
      },
      getAddSms() {
        this.$refs.addCellPhoneForm.validate(['addtel']).then(() => {
          this.addCellPhoneModal.isVerify = true;
        }).catch(err=>{});
      },
      getAddPhoneStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.addCellPhoneModal.form.verify = 'success';
        } else {
          this.addCellPhoneModal.form.verify = '';
        }
      },
      getAddPhoneResult(val) {
        if(val === 'success') {
          // 图形校验成功
          this.addCellPhoneModal.isVerify = false;
          SendSms(this.addCellPhoneModal.form.addtel).then((res) => {
            if (!res.result){
              this.addCellPhoneModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getAddPhoneYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getAddPhoneYzm(surplus_time) {
        // 展示等待时间
        this.addCellPhoneModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.addCellPhoneModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.addCellPhoneModal.isGetYzm = false;
            this.addCellPhoneModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      submitAddPhoneForm() {
        this.$refs.addCellPhoneForm.validate().then(() => {
          AddCellPhone(this.addCellPhoneModal.form)
            .then((res) => {
              if (!res.result) {
                if (res.notify_session_url) {
                    window.location.href = res.notify_session_url + "&refer_url=" + this.$route.query.url;
                  } else {
                    // this.loginModal.visible = false;
                    if (this.user.is_authenticated) {
                        this.user.cellphone = true;
                        this.addCellPhoneModal.visible = false;
                    } else {
                      this.goNext();
                    }
                  }
              } else {
                this.addCellPhoneModal.error = res.msg;
              }
            }).catch((err) => {
              showMessage('服务异常，请稍后再试')
            })
        }).catch(err=>{
          return false
        });
      },
      closeAddPhoneModal() {
        this.addCellPhoneModal.error = '';
        this.$refs.addCellPhoneForm.resetValidation();
        if (this.user.is_authenticated && !this.user.cellphone) {
          this.$router.go(0);
        }
      },
      closeLoginModal() {
        this.loginModal.login_error = "";
        this.loginModal.register_error = "";
        this.loginModal.isVerify = false;
        if (this.loginModal.isLogin) {
          this.$refs.loginForm.resetValidation();
        } else {
          this.$refs.registerForm.resetValidation();
        }
      },

      //注册
      getSms() {
        // 点击获取验证码，先弹出图形校验
        this.$refs.registerForm.validate(['register_tel', 'register_pwd']).then(() => {
          this.loginModal.isVerify = true;
        }).catch(err=>{});
      },
      closeForgetPwdModal() {
        this.forgetPwdModal.error = '';
        this.forgetPwdModal.visible = false;
        this.forgetPwdModal.isGetYzm = false;
        this.forgetPwdModal.isVerify = false;
        this.loginModal.visible = true;
        this.$refs.forgetPwdForm.resetValidation();
      },
      canUseCookie(){
        setCookie('fnedu_test_cookie', 1)
        let test = getCookie('fnedu_test_cookie')
        if(test && test == 1){
          this.useCookie = true
        }
        else{
          this.useCookie = false
        }
      },
      submitRegisterForm() {
        this.loginModal.register_error = '';
        this.$refs.registerForm.validate().then(() => {
            RegisterUser(this.loginModal.registerForm)
              .then((res) => {
                if (!res.result) {
                  if (!res.result) {
                    if (res.notify_session_url) {
                      window.location.href = res.notify_session_url + "&refer_url=" + this.$route.query.url;
                    } else {
                      this.goNext();
                    }
                  } else {
                    this.loginModal.login_error = res.msg
                  }
                } else {
                  this.loginModal.register_error = res.msg
                }
              }).catch((err) => {
                showMessage('服务异常，请稍后再试')
            })
        }).catch(err=>{
          return false
        });
      },
      getRegisterStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.loginModal.registerForm.verify = 'success';
        } else {
          this.loginModal.registerForm.verify = '';
        }
      },
      getRegisterResult(val) {
        if(val === 'success') {
          // 图形校验成功
          this.loginModal.isVerify = false;
          SendSms(this.loginModal.registerForm.register_tel).then((res) => {
            if (!res.result){
              this.loginModal.registerForm.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      openLogin() {
        this.showLogin = false;
        this.loginModal.register_error = "";
        this.$refs.registerForm.resetValidation();
        this.loginModal.isLogin = true;
        this.loginModal.isVerify = false
        this.changeFormAnimation(that => {
          that.loginModal.visible = true;
        });
      },
      // 忘记密码
      showForgetPwd() {
        this.forgetPwdModal.visible = true;
        this.loginModal.visible = false;
      },
      getForgetSms() {
        this.$refs.forgetPwdForm.validate(['forget_tel', 'pwd']).then(() => {
          this.forgetPwdModal.isVerify = true;
        }).catch(err=>{});
      },
      getForgetPwdStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.forgetPwdModal.form.verify = 'success';
        } else {
          this.forgetPwdModal.form.verify = '';
        }
      },
      getForgetPwdResult(val) {
        if(val === 'success') {
          // 图形校验成功
          this.forgetPwdModal.isVerify = false;
          SendSms(this.forgetPwdModal.form.forget_tel).then((res) => {
            if (!res.result){
              this.forgetPwdModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getForgetYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getForgetYzm(surplus_time) {
        // 展示等待时间
        this.forgetPwdModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.forgetPwdModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.forgetPwdModal.isGetYzm = false;
            this.forgetPwdModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      submitForgetForm() {
        this.$refs.forgetPwdForm.validate().then(() => {
            ForgetPWD(this.forgetPwdModal.form)
              .then((res) => {
                if (!res.result) {
                  this.forgetPwdModal.visible = false;
                } else {
                  this.forgetPwdModal.error = res.msg;
                }
              }).catch((err) => {
                showMessage('服务异常，请稍后再试')
            })
        }).catch(err=>{
          return false
        });
      },
      //获取验证码
      getYzm(surplus_time) {
        // 展示等待时间
        this.loginModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.loginModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.loginModal.isGetYzm = false;
            this.loginModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      goPath(path) {
        this.$router.push(path)
      },
      goNext() {
        if (this.$route.name === "Login") {
          let next_url = this.$route.query.next ? this.$route.query.next : "/mobile/home";
          if (next_url === "" || next_url === "/mobile") {
            next_url = "/mobile/home";
          }
          this.$router.push(next_url);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  #header {
    height:60px;
    line-height:60px;
    padding:15px 20px 0 20px;
    border-bottom:1px solid #f3f4f5;
    z-index:20;
    background:#fff;
    img {
      display:block;
      float:left;
      height:30px;
      margin-right:20px;
    }
  }
  .main {
    padding:20px 10px;
    :deep(.title_bg) {
      font-size:18px;
    }
    :deep(.log_form) {
      .van-cell-group {
        .van-cell {
          .van-field__control {
            height: 40px;
            background: #f3f3f3;
            border-radius: 4px;
            padding-left: 10px;
          }
          &:after {
            display:none;
          }
          &.extra {
            font-size:12px;
            .van-checkbox__label {
              color:#666;
            }
            .van-button {
              height:40px;
            }
            .agreement {
              padding:10px 0;
            }
          }
          &.slider_verify {
            .van-field__control {
              padding:0;
            }
          }
          &.custom_van_checkbox{
            .van-field__control {
              background: #fff;
            }
          }
        }
        .field_tel {
          .van-cell__title {
            position: absolute;
            left: 26px;
            z-index: 1;
            top: 18px;
            width: auto;
            padding-right: 10px;
            border-right: 1px solid #ccc;
          }
          .van-field__control {
            padding-left:75px;
          }
        }
        &:after {
          display:none;
        }
      }
    }
  }

  .third_login {
    position: relative;
    text-align: center;
    > a {
      > i{
        margin-left:15px;
        margin-right:15px;
        font-size:40px;
      }
    }
  }
</style>
